import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

import EventsStoreRidesInfoRoute from './Info';

const routes: CustomRoute = {
	path: appPath.eventsStoreRides.replace(appPath.events, ''),
	components: () => [],
	render: (_, children) => children,
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'eventsStoreRides' */ './component')],
			render: ([EventsStoreRides]) => <EventsStoreRides />,
		},
		EventsStoreRidesInfoRoute,
	],
};

export default routes;
